import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryVppApplicationsEffects } from './category-vpp-applications.effects';
import { categoryVppApplicationsReducer } from './category-vpp-applications.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('categoryVppApplications', categoryVppApplicationsReducer),
    EffectsModule.forFeature([CategoryVppApplicationsEffects]),
  ],
  providers: [],
})
export class CategoryVppApplicationsStoreModule {}
